import { useState } from 'react'
import TopBar from '@/src/components/layout/top-bar/TopBar'
import { Outlet } from 'react-router-dom'

const Layout = () => {
  const [title, setTitle] = useState('')
  const [subTitle, setSubTitle] = useState('')
  return (
    <div className="h-dvh flex flex-col">
      <TopBar variant="dark" title={title} subtitle={subTitle || undefined} />
      <main className="flex-1 overflow-hidden bg-primary-blue pt-2">
        <Outlet context={{ setTitle, setSubTitle }} />
      </main>
    </div>
  )
}

export default Layout
